import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function hasTime(date: string): boolean {
    return !!(date && date.includes("T") && date.includes(":"));
}

const dateCache = new Map<string, string>();

export default function ConvertDateToFa(date: string): string {
    if (!date) return "";
    const cached = dateCache.get(date);
    if (cached !== undefined) return cached;

    try {
        const data = new DateObject({
            calendar: gregorian,
            date: new Date(date),
            locale: persian_fa,
            format: "YYYY/MM/DD HH:mm:ss",
        }).convert(persian);

        const formatString = hasTime(date) ? "YYYY/MM/DD HH:mm" : "YYYY/MM/DD";
        const result = data.format(formatString);
        if (dateCache.size > 2000) {
            dateCache.clear();
        }
        dateCache.set(date, result);
        return result;
    } catch {
        return date;
    }
}
